module.exports = __webpack_public_path__ + "images/artist_130.f960abe87cc4760bcb6c78a2f0381fbd.png";